/* Bondi Bark Sales Page — interactive behaviour
 * Countdown timer, accordions (mini-FAQ + main FAQ), bundle selector, thumbnail switching, smooth scroll.
 * Self-initialising, idempotent.
 */
(function () {
  if (window.__bondibarkSalesPageInit) return;
  window.__bondibarkSalesPageInit = true;

  // ===== Countdown timer =====
  function pad(n) { return String(n).padStart(2, '0'); }

  function startCountdown(el) {
    var endIso = el.getAttribute('data-end');
    var fallbackHours = parseInt(el.getAttribute('data-fallback-hours') || '24', 10);
    var endTime;

    if (endIso) {
      endTime = new Date(endIso).getTime();
      if (isNaN(endTime) || endTime < Date.now()) {
        endTime = Date.now() + fallbackHours * 3600 * 1000;
      }
    } else {
      // Persistent fallback: store target in localStorage so it doesn't reset on refresh
      var key = 'bb-countdown-target-' + (el.id || 'default');
      var stored = parseInt(localStorage.getItem(key) || '0', 10);
      if (!stored || stored < Date.now()) {
        stored = Date.now() + fallbackHours * 3600 * 1000;
        try { localStorage.setItem(key, String(stored)); } catch (e) {}
      }
      endTime = stored;
    }

    var hrsEl = el.querySelector('[data-cd="hrs"]');
    var minsEl = el.querySelector('[data-cd="mins"]');
    var secsEl = el.querySelector('[data-cd="secs"]');

    function tick() {
      var diff = Math.max(0, endTime - Date.now());
      var totalSec = Math.floor(diff / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      if (hrsEl) hrsEl.textContent = pad(h);
      if (minsEl) minsEl.textContent = pad(m);
      if (secsEl) secsEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('.bb-countdown-bar[data-countdown]').forEach(startCountdown);

  // ===== FAQ + mini-FAQ accordion =====
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bb-faq-q, .bb-mini-faq-q');
    if (!btn) return;
    var item = btn.closest('.bb-faq-item, .bb-mini-faq-item');
    if (!item) return;
    var isOpen = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  // ===== Bundle selection =====
  document.addEventListener('click', function (e) {
    var bundle = e.target.closest('.bb-bundle');
    if (!bundle) return;
    var group = bundle.closest('.bb-bundles');
    if (!group) return;

    group.querySelectorAll('.bb-bundle').forEach(function (b) { b.classList.remove('is-selected'); });
    bundle.classList.add('is-selected');

    // If the bundle has a variant id, update the ATC form accordingly
    var variantId = bundle.getAttribute('data-variant-id');
    var priceNew = bundle.getAttribute('data-price-new');
    var priceOld = bundle.getAttribute('data-price-old');
    var hero = bundle.closest('.bb-hero-section, .bondibark-scope');
    if (hero) {
      var form = hero.querySelector('form[data-bb-cart-form]');
      if (form) {
        if (variantId) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = variantId;
        }
        // Quantity logic: ALWAYS read data-quantity from the selected bundle.
        // Each bundle on this product is a quantity multiplier of the same variant
        // (Buy 1 -> 1, Buy 2+1 Free -> 3, Buy 3+3 Free -> 6).
        var qty = 1;
        var qtyAttr = bundle.getAttribute('data-quantity');
        if (qtyAttr) {
          var parsed = parseInt(qtyAttr, 10);
          if (!isNaN(parsed) && parsed > 0) qty = parsed;
        }
        var qtyInput = form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = String(qty);
          qtyInput.setAttribute('value', String(qty));
          // Bubble the change so theme/cart drawers re-read it
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      var priceNewEl = hero.querySelector('[data-bb-atc-price-new]');
      var priceOldEl = hero.querySelector('[data-bb-atc-price-old]');
      if (priceNewEl && priceNew) priceNewEl.textContent = priceNew;
      if (priceOldEl && priceOld) priceOldEl.textContent = priceOld;
    }
  });

  // ===== Smooth scroll for in-scope anchor links =====
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.bondibark-scope a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });


  // ===== Hero image carousel — sync thumbnails + arrows with scroll-snap carousel =====
  (function initHeroCarousel() {
    var carousel = document.querySelector('[data-bb-carousel]');
    if (!carousel) return;
    var slides = carousel.querySelectorAll('.bb-hero-slide');
    var thumbs = document.querySelectorAll('.bb-hero-thumb[data-bb-thumb-index]');
    var arrows = document.querySelectorAll('[data-bb-arrow]');
    if (!slides.length) return;

    function setActiveThumb(idx) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      var active = document.querySelector('.bb-hero-thumb[data-bb-thumb-index="' + idx + '"]');
      if (active) {
        active.classList.add('is-active');
        // Also scroll the active thumb into view in its strip
        try { active.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' }); } catch (e) {}
      }
    }

    // Click thumbnail → scroll carousel to that slide
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = parseInt(thumb.getAttribute('data-bb-thumb-index'), 10);
        var target = slides[idx];
        if (!target) return;
        carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        setActiveThumb(idx);
      });
    });

    // Arrow buttons (prev/next)
    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var direction = arrow.getAttribute('data-bb-arrow');
        var slideWidth = carousel.clientWidth;
        var currentIdx = Math.round(carousel.scrollLeft / slideWidth);
        var nextIdx = direction === 'next' ? currentIdx + 1 : currentIdx - 1;
        if (nextIdx < 0) nextIdx = 0;
        if (nextIdx >= slides.length) nextIdx = slides.length - 1;
        var target = slides[nextIdx];
        if (target) {
          carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          setActiveThumb(nextIdx);
        }
      });
    });

    function updateArrowState(idx) {
      arrows.forEach(function (a) {
        var dir = a.getAttribute('data-bb-arrow');
        if (dir === 'prev') a.disabled = (idx <= 0);
        else if (dir === 'next') a.disabled = (idx >= slides.length - 1);
      });
    }

    // Scroll/swipe → update active thumbnail + arrow state (debounced via rAF)
    var rafId = null;
    carousel.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        var scrollLeft = carousel.scrollLeft;
        var slideWidth = carousel.clientWidth;
        var idx = Math.round(scrollLeft / slideWidth);
        if (idx >= 0 && idx < slides.length) {
          setActiveThumb(idx);
          updateArrowState(idx);
        }
      });
    });

    // ===== Mouse drag-to-scroll (desktop) =====
    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var hasDragged = false;

    carousel.addEventListener('mousedown', function (e) {
      isDown = true;
      hasDragged = false;
      startX = e.pageX - carousel.offsetLeft;
      startScrollLeft = carousel.scrollLeft;
      carousel.style.cursor = 'grabbing';
    });
    carousel.addEventListener('mouseleave', function () {
      if (!isDown) return;
      isDown = false;
      carousel.style.cursor = 'grab';
      snapToNearestSlide();
    });
    carousel.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      carousel.style.cursor = 'grab';
      snapToNearestSlide();
    });
    carousel.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - carousel.offsetLeft;
      var walk = (x - startX);
      if (Math.abs(walk) > 4) hasDragged = true;
      carousel.scrollLeft = startScrollLeft - walk;
    });

    // Prevent click from triggering after drag
    carousel.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);

    function snapToNearestSlide() {
      var slideWidth = carousel.clientWidth;
      var idx = Math.round(carousel.scrollLeft / slideWidth);
      if (idx < 0) idx = 0;
      if (idx >= slides.length) idx = slides.length - 1;
      var target = slides[idx];
      if (target) {
        carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        setActiveThumb(idx);
        updateArrowState(idx);
      }
    }

    // Initialize arrow state
    updateArrowState(0);
  })();
})();

